import { useMutation, useQueryClient } from 'react-query';
import { videoTagsKeys } from './videoTagsKeys';
import { useToastError } from 'lib/hooks';
import { useTranslation } from 'react-i18next';
import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';

interface IUpdateVideoTagsBody {
  videoId: string;
  data: object[];
}

export const putVideoTags = async ({ videoId, data }: IUpdateVideoTagsBody) => {
  const response = await EXPRESS_API.put(`/videos/${videoId}/video-tags`, data);
  return { videoTags: response.data };
};

export const useSaveTagsMutation = (videoId: number) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  const { t } = useTranslation();

  return useMutation(putVideoTags, {
    onSuccess: () => {
      queryClient.invalidateQueries(videoTagsKeys.video(videoId));
      successToast({ title: t('Tags saved successfully.') });
    },
    onError: e => {
      showError(e, t('There was a problem saving tags. Please try again.'));
    },
  });
};
